import * as React from "react";

import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Library.css";


// action to scroll to the robot name
window.addEventListener('load', () => {
    let showname = /n=([^&]+)/.exec(window.location.search);
    if (!showname) { return; }
    let robid = document.getElementById(showname[1]);
    if (!robid) { return; }
    console.log("Scrolling to: " + showname[1])
    robid.scrollIntoView({ behavior: 'smooth', block: "center" });
});

const start = performance.now();

console.log("Setup time (ms): " + (performance.now() - start));


export const Library = (props: any) => {
    const [init, setInit] = React.useState(true);

    React.useEffect(() => {
        if (init) {
            // Check if library is opened from RoboDK Web
            if (window.location.search.includes("RoboDK-Web&")) {
                window.Settings.open_in_rdk = true;
                window.Settings.on_robodk_web = true;
            }

            setInit(false);
        }
    });

    return (
        <>
            <div className="library">
                <div className="row cards">
                    {props.noItemsMessage != "" && (
                        <h4>{props.noItemsMessage}</h4>
                    )}

                    {props.sortFilteredItems.map((card) => (
                        <div
                            key = {"row-" + card["name"]}
                            className="card g-2 col col-12 col-sm-6 col-md-4 col-xl-3 col-xxl-3"
                        >
                            {window.Configs.component_cards[card["name"]]}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};
